<table class="task">
  <tbody>
  <tr>
    <td></td>
    <td class="question">
      {{ question.text }}
    </td>
  </tr>
  <tr>
    <td class="number">{{ questIndex + 1 }}.</td>
    <td class="answer">
      <div class="input-group big active">
              <span class="cross-icon" (click)="questionClearAnswer()">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <defs>
                    <style>.question-close-cls-1,.question-close-cls-2{fill:none;}.question-close-cls-2{stroke:#ccc;stroke-miterlimit:10;stroke-width:2px;} .cross-icon:hover .question-close-cls-2{stroke:#999999;stroke-miterlimit:10;stroke-width:2px;}</style>
                  </defs>
                  <title></title>
                  <g id="Слой_2" data-name="Слой 2">
                    <g id="Слой_10" data-name="Слой 10">
                      <rect class="question-close-cls-1" width="24" height="24"/>
                      <line class="question-close-cls-2" x1="1.5" y1="1.5" x2="22.5" y2="22.5"/>
                      <line class="question-close-cls-2" x1="1.5" y1="22.5" x2="22.5" y2="1.5"/>
                    </g>
                  </g>
                </svg>
              </span>
        <input type="text" [(ngModel)]="answerString" class="text-left">
      </div>
    </td>
  </tr>
  <tr>
    <td></td>
    <td class="answer-vars">
      <div class="justify-content-between logic-answers" *ngIf="exercise.words">
        <span
          *ngFor="let word of exercise.words"
          (click)="keyboardQuestionClicked(word.word)" appDisTouchmove>
            {{ word.word }}
        </span>
        <span>
          <a class="enter" (click)="questionCheckAnswer()" style="cursor: pointer;" appDisTouchmove>
            <img src="/assets/images/enter.png" alt="" />
          </a>
        </span>
      </div>
    </td>
  </tr>
  </tbody>
</table>
